"use client";

import { Button } from "@/components/ui/button";
import { useCallback } from "react";
import { useStorageQuery } from "../../../../hooks/storageQueryProvider";
import { GetFilesResponseType } from "../../../../hooks/useGetFiles";
import { t } from "@/lib/localization";

export default function SelectAll({
    files,
}: {
    files?: GetFilesResponseType["data"];
}) {
    const { selectedFiles, setSelectedFiles } = useStorageQuery();

    const toggleSelectAll = useCallback(() => {
        if (!files?.length) return;

        const someVisibleFilesSelected = files.some((file1) =>
            selectedFiles.some((file2) => file1.id === file2.id)
        );

        if (someVisibleFilesSelected) {
            setSelectedFiles((prev) =>
                prev.filter((file1) =>
                    files.every((file2) => file1.id !== file2.id)
                )
            );
        } else {
            setSelectedFiles((prev) => [...prev, ...files]);
        }
    }, [files, selectedFiles, setSelectedFiles]);

    return (
        <Button
            onClick={toggleSelectAll}
            className="font-normal text-sm"
            variant="outline"
            size="sm"
        >
            {t("storage.files-grid.select-all-btn", undefined, undefined)}
        </Button>
    );
}
